const BASE_URL = '/admin/ai-prompts';

const getPromptUrl = (tenantId, promptType) =>
  `${BASE_URL}/${tenantId}/${promptType}`;

export const getAIPromptClients = async () => {
  const response = await fetch(BASE_URL);
  if (response.status !== 200) throw new Error();

  const data = await response.json();
  return data.clients;
};

export const getAIPrompt = async (tenantId, promptType) => {
  const response = await fetch(getPromptUrl(tenantId, promptType));
  if (response.status !== 200) throw new Error();

  const data = await response.json();
  return data.prompt;
};

// Returns the new status of the prompt. On a prompt with unknown {{fields}} the error has their names.
export const saveAIPrompt = async (tenantId, promptType, prompt) => {
  const response = await fetch(getPromptUrl(tenantId, promptType), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt }),
  });
  const data = await response.json().catch(() => ({}));

  if (response.status !== 200) {
    const error = new Error();
    error.unknownFields = data.unknownFields;
    throw error;
  }

  const { hasPrompt, isEnabled, updatedOn, updatedBy } = data;
  return { hasPrompt, isEnabled, updatedOn, updatedBy };
};

export const setAIPromptEnabled = async (tenantId, promptType, isEnabled) => {
  const response = await fetch(
    `${getPromptUrl(tenantId, promptType)}/enabled`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ isEnabled }),
    },
  );
  if (response.status !== 200) throw new Error();

  return response.json();
};

export const deleteAIPrompt = async (tenantId, promptType) => {
  const response = await fetch(getPromptUrl(tenantId, promptType), {
    method: 'DELETE',
  });
  if (response.status !== 204) throw new Error();
};
